import { render, staticRenderFns } from "./customerWithIdentifications.vue?vue&type=template&id=6eaef788"
import script from "./customerWithIdentifications.vue?vue&type=script&lang=js"
export * from "./customerWithIdentifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports